export const WFHStatusType = {
  PENDING: 'Pending',
  ACCEPTED: 'Accepted',
  REJECTED: 'Rejected',
};
export const WFH = 'Work From Home';
export const WFH_STATUS = 'WFH Status';

export const APPROVED = 'APPROVED';
export const REJECTED = 'REJECTED';
export const PENDING = 'PENDING';
export const CANCELLED = 'CANCELLED';

export const wfhStatus = (status) => {
  if (status === 'APPROVED') return 'Approved';
  else if (status === 'PENDING') return 'Pending';
  else if (status === 'REJECTED') return 'Rejected';
  else if (status === 'CANCELLED') return 'Cancelled';
  return status;
};

export const WFHStatusButton = {
  REJECTED: 'Rejected',
  REJECT: 'Reject',
  APPROVED: 'Approved',
  APPROVE: 'Approve',
  ADD_TASK: 'Add Task',
  CANCEL: 'Cancel',
  RESCHEDULE: 'Reschedule',
  EDIT_TASK: 'Edit Task',
};
